
  import { defineComponent, onMounted, ref } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useRoute, useRouter } from 'vue-router';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import * as Yup from 'yup';
  import { SubscriptionObject } from '@/store/modules/Subscriptions/SubscriptionModule';

  export default defineComponent({
    name: 'subscriptions-editing',
    components: {
      ErrorMessage,
      Field,
      Form,
    },
    async setup() {
      const { t, te } = useI18n();
      const { can } = useAbility();
      const store = useStore();
      const router = useRouter();
      const route = useRoute();
      const submitButton = ref<HTMLButtonElement | null>(null);
      const submitServicesButton = ref<HTMLButtonElement | null>(null);
      const submitPricesButton = ref<HTMLButtonElement | null>(null);
      const multiselect = ref(null);
      const createdPackage = ref<SubscriptionObject | null>(null);
      const loading = ref(false);

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const goBack = () => {
        router.back();
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('subscriptionsUpdating'), [
          translate('subscriptions'),
        ]);
      });

      const { data } = await store.dispatch(
        Actions.GET_SUBSCRIPTION,
        route.params.id
      );

      const packages = ref<SubscriptionObject>(data.data);
      if (packages.value.color) {
        packages.value.color = packages.value.color.slice(0, 7);
      }
      // console.log(packages);
      // const selectedServices = ref<Array<number>>([1]);
      // const selectedServices = ref<Array<number>>(
      //   data.data.adsServicesPackages.map((a) => a.serviceId)
      // );
      const packageSchema = Yup.object().shape({
        titleAr: Yup.string()
          .required(() => translate('AR_TITLE_IS_REQUIRED_FIELD'))
          .label('Arabic Title'),
        titleEn: Yup.string()
          .required(() => translate('EN_TITLE_IS_REQUIRED_FIELD'))
          .label('English Title'),
        descriptionAr: Yup.string()
          .required(() => translate('DESCRIPTION_IS_REQUIRED_FIELD'))
          .label('Arabic Description'),
        descriptionEn: Yup.string()
          .required(() => translate('DESCRIPTION_IS_REQUIRED_FIELD'))
          .label('English Description'),

        price: Yup.string()
          .required(() => translate('PRICE_IS_REQUIRED_FIELD'))
          .label('Ads Package Price'),
        sort: Yup.string()
          .required(() => translate('SORT_IS_REQUIRED_FIELD'))
          .label('Sort'),
      });
      const onSubmitUpdate = async (values) => {
        debugger;
        console.log(values);
        if (submitButton.value) {
          // eslint-disable-next-line
          submitButton.value!.disabled = true;
          submitButton.value.setAttribute('data-kt-indicator', 'on');
        }
        values.price = Number(values.price);
        values.sort = Number(values.sort);
        if (values.color) {
          const alpha = values.color.slice(7) || '33'; // Default alpha if missing
          values.color = values.color + alpha;
        }
        await store.dispatch(Actions.UPDATE_SUBSCRIPTION, {
          id: packages.value?.id,
          data: values,
        });

        const [errorName] = Object.keys(store.getters.getErrors);
        const error = store.getters.getErrors[errorName];

        if (error) {
          Swal.fire({
            text: translate(error[0]),
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: translate('tryAgainExcl'),
            customClass: {
              confirmButton: 'btn fw-bold btn-light-danger',
            },
          });
          //Deactivate indicator
          submitButton.value?.removeAttribute('data-kt-indicator');
          // eslint-disable-next-line
          submitButton.value!.disabled = false;
        } else {
          Swal.fire({
            text: translate('SUCCESSFULLY_UPDATED_SUBSCRIPTION'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          }).then(() => {
            //Deactivate indicator
            submitButton.value?.removeAttribute('data-kt-indicator');
            // eslint-disable-next-line
            submitButton.value!.disabled = false;
            router.push({ name: 'subscriptions-listing' });
          });
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        packages,
        submitServicesButton,
        submitPricesButton,
        onSubmitUpdate,
        submitButton,
        translate,
        packageSchema,
        goBack,
        can,
        multiSelectLabel: 'title',
        loading,
        multiselect,
        createdPackage,
      };
    },
  });
